import { animate, state, style, transition, trigger } from '@angular/animations';
import { NgClass, NgIf } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatCell, MatCellDef, MatColumnDef, MatHeaderCell, MatHeaderCellDef, MatHeaderRow, MatHeaderRowDef, MatRow, MatRowDef, MatTable, MatTableDataSource } from '@angular/material/table';
import { ChecklistItem } from '@gsm/entities';
import { MomentModule } from 'ngx-moment';
import { CustomDynamicFormControlComponent } from '../custom-dynamic-form-control.component';
import { NachrichtenverlaufModel } from './nachrichtenverlauf.model';
// NOTE:
// The base class CustomDynamicFormControlComponent already includes all inputs and outputs needed, as well
// as additional convenience methods onDisabledChange() and onValueChange, for when model.disabled and model.value change,
// respectively.

@Component({
  selector:    'gsm-nachrichtenverlauf',
  templateUrl: 'nachrichtenverlauf.component.html',
  styleUrls:   ['nachrichtenverlauf.component.scss'],
  animations:  [
    trigger('detailExpand', [
      state('collapsed, void', style({
        height:    '0px',
        minHeight: '0',
        display:   'none'
      })),
      state('expanded', style({height: '*'})),
      transition('expanded <=> collapsed', animate('250ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
      transition('expanded <=> void', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)'))
    ])
  ],
  standalone:  true,
  imports:     [
    MatTable,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatIconButton,
    NgIf,
    MatIcon,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    NgClass,
    MomentModule
  ]
})
export class NachrichtenverlaufComponent extends CustomDynamicFormControlComponent<NachrichtenverlaufModel> implements OnInit {
  displayedColumns: string[] = [
    'iconToggle',
    'dokumentTyp',
    'createdOn',
    'changedOn'
  ];
  expandedElement: ChecklistItem | null;
  nachrichtenverlaufDataSource = new MatTableDataSource<ChecklistItem>();

  constructor() {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
  }

  protected onModelChange(): void {
    super.onModelChange();
    this.nachrichtenverlaufDataSource.data = this.model.value;
  }

  toggleRowExpand(row) {
    this.expandedElement !== row ? (this.expandedElement = row) : (this.expandedElement = null);
  }

  getChecklistStatusLabel(status): string {
    return ChecklistStatusLabel[status];
  }

  getWertLabel(typeId: string): string {
    return WertLabel[typeId];
  }

  getGrundLabel(typeId: string): string {
    return GrundLabel[typeId];
  }

  getStatusLabel(typeId: string, status: string, isAdm: boolean): string {
    if (typeId === 'ABLOS' && isAdm && (status === 'H' || status === 'E')) {
      if (status === 'H') {
        return 'Abgelehnt';
      } else {
        return 'Angenommen';
      }
    } else {
      return this.getChecklistStatusLabel(status);
    }
  }
}

enum ChecklistStatusLabel {
  O = 'Wird nachgebracht',
  E = 'Erledigt',
  R = 'Eingabe erforderlich',
  N = 'Nicht verfügbar',
  H = 'Hinfällig',
}

enum WertLabel {
  SCH_FRAG = 'Antwort',
  INFO = 'Wert',
  NACH_REF = 'Nachricht',
  ABLOS = 'Wert',
}

enum GrundLabel {
  SCH_FRAG = 'Frage',
  INFO = 'Info',
  NACH_REF = 'Grund',
  ABLOS = 'Grund',
}
